import Moment from 'moment'
import * as Redux from 'redux'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Sortable from '../../components/sortable'
import * as RootConstants from '../../constants'
import * as Request from '../../request'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'

interface PromotionsPayload {
  promotions: Types.Promotion[],
}

const normalizeTypes: Sortable.TypeNormalizer<Types.Promotion> =
  (payload: PromotionsPayload): Sortable.SortableData<Types.Promotion> => {
  return payload.promotions.map((p: Types.Promotion) => ({
    ...p,
    created_datetime: Moment(p.created),
    end_datetime: Moment(p.end_date),
    preview_image_url: p.preview_image_url || p.image_url,
    start_datetime: Moment(p.start_date),
  }))
}

const reducerEvent: Sortable.ReducerEvent<Types.Promotion> = {
  defaultSort: {field: 'id', dir: 'desc'},
  normalizer: normalizeTypes,
  requestEvent: Constants.FETCH_PROMOTIONS,
}

const modalReducerEvent: Modal.ReducerEvent<Types.ModalData> = {
  initializeState: () => Constants.emptyModalState,
  requestEvent: Constants.ADD_PROMOTION,
}

const emptyViewState: Types.PromotionsViewState = {
  filter: IsActive.FILTER_STATUS_ACTIVE,
  isLoading: false,
  sort: [],
}

// General purpose signature of Promotions modal reducers.
type PromotionsModalReducer = Redux.Reducer<Modal.State<Types.ModalData>>

// Reducer #1: Listens for the Edit Promotion action and populates the modal data with
// the currently selected data, passed on the EditPromotionAction
type ModalActions = Redux.Action & Actions.EditPromotionAction & Request.SuccessAction
export const editModalReducer: PromotionsModalReducer =
  (state: Modal.State<Types.ModalData>, action: ModalActions): Modal.State<Types.ModalData> => {
  switch (action.type) {
    case Constants.EDIT_PROMOTION:
      return {
        ...state,
        data: {
          category_type_id: action.promotion.category_type_id,
          date_parameter: action.promotion.date_parameter,
          email_parameter: action.promotion.email_parameter,
          emailhash_parameter: action.promotion.emailhash_parameter,
          end_date: action.editType === RootConstants.CLONE ? null : action.promotion.end_datetime,
          id: action.editType === RootConstants.CLONE ? null : action.promotion.id,
          image_url: action.promotion.image_url,
          person_parameter: action.promotion.person_parameter,
          promotion_id: action.promotion.promotion_id,
          promotion_type_id: action.promotion.promotion_type_id,
          rank: action.promotion.rank,
          start_date: action.editType === RootConstants.CLONE ? null : action.promotion.start_datetime,
          target_url: action.promotion.target_url,
          title: action.promotion.title,
          token_parameter: action.promotion.token_parameter,
        },
        isOpen: true,
        modalTitle: action.editType === RootConstants.CLONE ? 'Clone Promotion' : 'Update Promotion',
      }
    case Request.successConstant(Constants.EDIT_PROMOTION):
      return {
        ...state,
        isOpen: false,
      }
    case Modal.toggleModalConstant(modalReducerEvent.requestEvent):
      return {
        ...state,
        data: Constants.emptyModalState,
        modalTitle: 'Add New Promotion',
      }
    default:
      return state
  }
}

// Reducer #2: The default modal listener, handling the general purpose modal events (toggle, edit, etc...)
const generalModalReducer: PromotionsModalReducer = Modal.reducer(modalReducerEvent)

type PromotionsDataReducer = Redux.Reducer<Sortable.SortableData<Types.Promotion>>
const sortableReducer: PromotionsDataReducer = IsActive.dataReducer(Constants.UPDATE_PROMOTION)
const isActiveReducer: PromotionsDataReducer = Sortable.stateReducer(reducerEvent)

export const reducer = Redux.combineReducers({
  data: Request.reducerChain([sortableReducer, isActiveReducer]),
  modal: Request.reducerChain([generalModalReducer, editModalReducer]),
  view: IsActive.filterReducer(
    Sortable.viewReducer(reducerEvent), Constants.FETCH_PROMOTIONS, emptyViewState),
})



// WEBPACK FOOTER //
// ./src/pages/promotions/reducer.ts